import { React, useEffect, useState } from "react";
import {
  FormControl,
  Icon,
  Paper,
  LinearProgress,
  linearProgressClasses,
  Avatar,
  Divider,
  Checkbox,
  FormControlLabel,
  Button,
  Typography,
  CssBaseline,
  IconButton,
  Snackbar,
  Alert,
  Box,
  Stack,
} from "@mui/material";

import dayjs from "dayjs";
import "dayjs/locale/pt-br";

import iconEdit from "../../images/icon-edit.png";

import { createTheme, styled, ThemeProvider } from "@mui/material/styles";

import DialogSuccess from "../../components/dialogs/DialogSuccess";
import { PhotoCameraOutlined } from "@mui/icons-material";

import {
  FieldInputText,
  FieldDatePicker,
  FieldSelect,
  FieldAutocomplete,
  FieldInputMask,
} from "../../components/Fields";

import { isEmail } from "../../utils/validacaoDadosPaciente";

import { conselhos, ufs, unasus_cbo, estadosCivil, racas, sexos } from "./data";

import { styles } from "./styles";

import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import axios from "axios";
import { getItemDecrypt } from "../../utils/cryptoData";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: "20px",
  width: "1046px",
  borderRadius: "100px",
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: "0px",
    backgroundColor: theme.palette.mode === "light" ? "#3AB238" : "#D9D9D9",
  },
}));

const theme = createTheme({
  palette: { primary: { main: "#1E729F" } },
});

// llisatagem
const filtroCboList = (itemCbo) => {
  const profissoesPermitidas = [
    "Médico neurologista",
    "Médico clínico",
    "Fisioterapeuta geral",
    "Nutricionista",
    "Fonoaudiólogo geral",
    "Psicólogo clínico",
    "Administrador de sistemas operacionais",
    "Enfermeiro",
  ];
  return profissoesPermitidas.includes(itemCbo.no_descricao);
};

const LoginPage = () => {
  //dados gerais
  const [profileImg, setProfileImg] = useState("");
  const [nomeCompleto, setNomeCompleto] = useState("");
  const [cns, setCns] = useState("");
  const [cpf, setCpf] = useState("");
  const [dataNascimento, setDataNascimento] = useState(null);
  const [nomeDaMae, setNomeDaMae] = useState("");
  const [sexo, setSexo] = useState("");
  const [raca, setRaca] = useState("");
  const [estadoCivil, setEstadoCivil] = useState("");
  //Dados profissionais
  const [conselho, setConselho] = useState("");
  const [registroConselho, setRegistroConselho] = useState("");
  const [cbo, setCbo] = useState("");
  const [cboList, setCboList] = useState([]);
  //contato
  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  //endereço
  const [cep, setCep] = useState("");
  const [isCepInvalid, setIsCepInvalid] = useState(false);
  const [logradouro, setLogradouro] = useState("");
  const [bairro, setBairro] = useState("");
  const [numero, setNumero] = useState("");
  const [complemento, setComplemento] = useState("");
  const [municipio, setMunicipio] = useState("");
  const [numeroCidade, setNumeroCidade] = useState("");
  const [estado, setEstado] = useState("");

  //Termos de uso e política de privacidade
  const [termoDeUso, setTermoDeUso] = useState(false);
  const [termoDePrivacidade, setTermoDePrivacidade] = useState(false);
  //Barra de progresso
  const [progresso, setprogresso] = useState(0);
  //

  const [editableDadosGerais, setEditableDadosGerais] = useState(false);
  const [editableProfissionais, setEditableProfissionais] = useState(false);
  const [editabledadosContato, setEditableContato] = useState(false);
  const [editableEndereco, setEditableEndereco] = useState(false);
  const [saveDialog, setSaveDialog] = useState(false);
  //

  const [baseImage, setBaseImage] = useState("");
  const [snackbar, setSnackbar] = useState(null);

  //dissable endereço
  const [disableLogradouro, setDisableLogradoura] = useState(false);
  const [disableBairro, setDisableBairro] = useState(false);
  const [disablebleMunicipio, setDisableMunicipio] = useState(false);
  const [disableEstado, setDisableEstado] = useState();

  const idadeMinima = 18;
  const dataMinima = dayjs().subtract(idadeMinima, "year");

  useEffect(() => {
    async function fetchData() {
      await Promise.all([getDataCBOList(), handleApi()]);
    }
    fetchData();
  }, []);

  useEffect(() => {
    calcularBarra();
  }, [
    profileImg,
    nomeCompleto,
    cns,
    cpf,
    dataNascimento,
    nomeDaMae,
    sexo,
    raca,
    estadoCivil,
    conselho,
    cbo,
    email,
    telefone,
    cep,
    logradouro,
    bairro,
    municipio,
    estado,
    termoDePrivacidade,
    termoDeUso,
    registroConselho,
  ]);

  async function handleApi() {
    let usuario = getItemDecrypt("usuario");

    const response = await api.post("/buscarProfissionalDeSaude", {
      cpf: usuario.no_cpf,
    });

    setNomeCompleto(response.data.no_nome_usuario);
    setCns(response.data.no_cns);
    setCpf(response.data.no_cpf.toString());

    setCbo(response.data.co_cbo);

    setDataNascimento(response.data.dt_nascimento || null);
    setNomeDaMae(response.data.no_nome_mae);
    setSexo(response.data.co_sexo_biologico);

    setRaca(response.data.co_raca_cor);

    setEstadoCivil(response.data.co_estado_civil);

    //Dados Profissionais
    setConselho(response.data.no_conselho || "");
    setRegistroConselho(response.data.no_conselho_numero || "");

    setCbo(response.data.co_cbo || "");

    //Contato
    setEmail(response.data.no_email || "");
    setTelefone("");

    //Endereço
    if (response.data.endereco) {
      setCep(response.data.endereco.no_cep || "");
      setLogradouro(response.data.endereco.no_logradouro || "");
      setBairro(response.data.endereco.no_bairro || "");
      setNumero(response.data.endereco.no_numero || "");
      setComplemento(response.data.endereco.no_complemento || "");
      setEstado(response.data.endereco.co_estado || "");
    }
  }

  const navigate = useNavigate();

  async function salvar(e) {
    e.preventDefault();
    const camposPreenchidos = [
      nomeCompleto,
      cns,
      cpf,
      dataNascimento !== null ? "true" : "",
      nomeDaMae,
      sexo,
      raca,
      estadoCivil,
      conselho,
      registroConselho,
      cbo,
      email,
      telefone,
      cep,
      logradouro,
      bairro,
      municipio,
      estado,
      termoDePrivacidade ? "true" : "",
      termoDeUso ? "true" : "",
    ];
    //every verificar se todos os campos passaram na validacao

    if (camposPreenchidos.every((campo) => campo !== "")) {
      try {
        const response = await api.put("/atualizarProfissinalDeSaudeUser", {
          user: {
            no_nome_usuario: nomeCompleto,
            no_cns: cns,
            no_cpf: cpf,
            dt_nascimento: dataNascimento,
            no_nome_mae: nomeDaMae,
            co_sexo_biologico: sexo,
            co_raca_cor: raca,
            co_estado_civil: estadoCivil,
            no_conselho: conselho,
            no_conselho_numero: parseInt(registroConselho),
            co_cbo: cbo,
          },
          address: {
            no_logradouro: logradouro,
            no_numero: numero,
            no_bairro: bairro,
            no_complemento: complemento,
            no_cep: cep,
            co_estado: estado,
            co_cidade: numeroCidade,
          },
          phoneNumber: telefone,
        });

        if (response.data.status === "Error") {
          setSnackbar({
            children: "Error: não foi possival salvar dados: erro de api",
            severity: "error",
          });
        } else {
          setSnackbar({
            children: "Dados salvo com sucesso",
            severity: "success",
          });

          //chamar funão atulizar
          navigate("/vinculos");
        }
      } catch (error) {
        setSnackbar({
          children: "Error: Não foi possivel se conectar com o servidor",
          severity: "error",
        });
        console.error(error);
      }
    } else {
      setSaveDialog(true);
    }
  }

  async function getDataCBOList() {
    const { data } = await api.get("/cbo/", {
      descricao: "dados",
    });
    setCboList(data.cbo);
  }

  function calcularBarra() {
    const camposPreenchidos = [
      profileImg,
      nomeCompleto,
      cns,
      cpf,
      dataNascimento !== null ? "True" : "",
      nomeDaMae,
      sexo,
      raca,
      estadoCivil,
      conselho,
      registroConselho,
      cbo,
      email,
      telefone,
      cep,
      logradouro,
      bairro,
      municipio,
      estado,
      termoDePrivacidade ? "true" : "",
      termoDeUso ? "true" : "",
    ];

    // Craindo um novo array com apenas os elementos preenchidos
    const count = camposPreenchidos.filter((campo) => campo !== "").length;
    const progresso = parseInt((count / camposPreenchidos.length) * 100);
    setprogresso(progresso);
  }

  function cancelar(params) {
    setEditableDadosGerais(false);
    setEditableProfissionais(false);
    setEditableContato(false);
    setEditableEndereco(false);
    setSaveDialog(false);
  }

  useEffect(() => {
    async function handleCep(auxCep) {
      try {
        const { data } = await axios.get(
          `https://viacep.com.br/ws/${auxCep}/json`
        );

        setBairro(data.bairro);
        setLogradouro(data.logradouro);
        setMunicipio(data.localidade);
        setNumeroCidade(data.ibge);

        setEstado(data.ibge.slice(0, 2));
        if (data.bairro) {
          setDisableBairro(true);
        } else {
          setDisableBairro(false);
        }

        if (data.logradouro) {
          setDisableLogradoura(true);
        } else {
          setDisableLogradoura(false);
        }

        if (data.localidade) {
          setDisableMunicipio(true);
        } else {
          setDisableMunicipio(false);
        }
        if (data.bairro) {
          setDisableEstado(true);
        } else {
        }
      } catch (error) {
        console.error();
      }
    }

    const auxCep = cep.replace(/\D/g, "");
    if (auxCep.length === 8) {
      handleCep(auxCep);
    } else {
      setDisableEstado(false);
      setDisableMunicipio(false);
      setDisableLogradoura(false);
      setDisableBairro(false);
    }
  }, [cep]);

  const handleUfChange = (event, newValue) => {
    setEstado(newValue && newValue.codigo_uf ? newValue.codigo_uf : null);
  };

  const handleCBOChange = (event, newValue) => {
    setCbo(newValue && newValue ? newValue.co_id : null);
  };

  return (
    <Box
      component="div"
      sx={{
        padding: { xs: "32px 16px", sm: "32px" },
      }}
    >
      <CssBaseline />
      <form onSubmit={salvar}>
        <Stack direction={"column"} justifyContent="center">
          <Paper
            style={styles.paper}
            sx={{
              boxSizing: "border-box !important",
              maxWidth: "1300px",
              width: "100%",
            }}
          >
            <Stack
              direction={"column"}
              gap={"8px"}
              justifyContent="center"
              sx={{
                boxSizing: "border-box !important",
                width: "100%",
              }}
            >
              <Stack
                direction={"row"}
                justifyContent="space-between"
                alignItems="center"
              >
                <Stack direction={{ xs: "column", sm: "row" }}>
                  <Box style={styles.textoProgresso1}>
                    {"Perfil intermederário, "}
                  </Box>
                  <Box style={styles.textoProgresso2}>
                    {" preencha os dados ausentes para completar"}
                  </Box>
                </Stack>
                <Box style={styles.textoProgresso1}>{progresso}%</Box>
              </Stack>

              <BorderLinearProgress
                variant="determinate"
                value={progresso}
                sx={{ boxSizing: "border-box !important", width: "100%" }}
              />
            </Stack>

            <Box
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "40px",
                width: "100%",
                boxSizing: "border-box !important",
              }}
              flexDirection={{ xs: "column", sm: "row" }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                  alignItems: "center",
                }}
              >
                <Avatar sx={styles.avatar} src={baseImage} />
                <Button
                  variant="outlined"
                  sx={styles.fotoButton}
                  component="label"
                  disabled={!editableDadosGerais}
                >
                  <input
                    hidden
                    accept=".png, .jpg, .jpeg"
                    type="file"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file.size < 1048576) {
                        const fileReader = new FileReader();
                        fileReader.readAsDataURL(file);
                        fileReader.onload = () => {
                          setBaseImage(fileReader.result);
                        };
                        fileReader.onerror = (error) => {
                          console.error("Error:", error);
                        };
                        setProfileImg(file);
                      } else {
                        setSnackbar({
                          children: "Error: Tamanho máximo permitido: 1MB",
                          severity: "error",
                        });
                      }
                    }}
                  />
                  <Stack
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    gap={"8px"}
                  >
                    <PhotoCameraOutlined fontSize="medium" />
                    <Typography
                      fontSize={"20px"}
                      fontWeight={600}
                      lineHeight={"27px"}
                    >
                      Selecionar foto
                    </Typography>
                  </Stack>
                </Button>
              </Box>

              <Stack direction={"column"} gap={"24px"} width={"100%"}>
                <Stack direction={"row"} alignItems={"center"}>
                  <Box style={styles.dadosGerais}>Dados gerais</Box>
                  <IconButton
                    onClick={() => {
                      setEditableDadosGerais(true);
                    }}
                  >
                    <Icon style={styles.iconEdit}>
                      <img src={iconEdit} alt="icone de edição" />
                    </Icon>
                  </IconButton>
                </Stack>

                <Stack
                  gap={"24px 16px"}
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
                    boxSizing: "border-box !important",
                  }}
                  width="100%"
                >
                  <FieldInputText
                    label="Nome completo"
                    value={nomeCompleto}
                    setValue={setNomeCompleto}
                    isEditField={editableDadosGerais}
                    required
                  />

                  <FieldInputMask
                    mask="999 9999 9999 9999"
                    label="CNS"
                    value={cns}
                    setValue={setCns}
                    isEditField={editableDadosGerais}
                    placeholder="000 0000 0000 0000"
                    error={cns?.includes("_")}
                    helperText={
                      cns?.includes("_") ? "Informe um cns válido" : ""
                    }
                    required
                  />
                  <FieldInputText
                    label="CPF"
                    value={cpf}
                    setValue={setCpf}
                    isEditField={editableDadosGerais}
                    disabled={true}
                    required
                  />
                  <FieldDatePicker
                    label="Data de nascimento"
                    value={dataNascimento}
                    setValue={setDataNascimento}
                    isEditField={editableDadosGerais}
                    required
                    maxDate={dataMinima}
                    labelDatePicker={"Data"}
                  />

                  <FieldInputText
                    label="Nome da mãe"
                    value={nomeDaMae}
                    setValue={setNomeDaMae}
                    isEditField={editableDadosGerais}
                    required
                    placeholder="Digite o nome da mãe"
                  />
                  <FieldSelect
                    label="Sexo"
                    value={sexo ?? ""}
                    setValue={setSexo}
                    items={sexos}
                    isEditField={editableDadosGerais}
                    required
                  />

                  <FieldSelect
                    label="Raça"
                    value={raca ?? ""}
                    setValue={setRaca}
                    items={racas}
                    isEditField={editableDadosGerais}
                    required
                    defaultValue=""
                  />

                  <FieldSelect
                    label="Estado Civil"
                    value={estadoCivil ?? ""}
                    setValue={setEstadoCivil}
                    items={estadosCivil}
                    isEditField={editableDadosGerais}
                    required
                  />
                </Stack>
              </Stack>
            </Box>
            <Divider />
            <Box sx={styles.containerDadosProfissionais}>
              <Stack direction={"row"} alignItems={"center"} gap={"8px"}>
                <Box style={styles.dadosGerais}>Dados profissionais</Box>
                <IconButton
                  onClick={() => {
                    setEditableProfissionais(true);
                  }}
                >
                  <Icon style={styles.iconEdit}>
                    <img src={iconEdit} alt="icone de edição" />
                  </Icon>
                </IconButton>
              </Stack>

              <Stack
                gap={"24px 16px"}
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
                  boxSizing: "border-box !important",
                }}
                width="100%"
              >
                <FieldSelect
                  label="Conselho de classe"
                  value={conselho}
                  setValue={setConselho}
                  items={conselhos.map((c) => {
                    return { id: c.sigla, label: c.sigla };
                  })}
                  isEditField={editableProfissionais}
                  required
                />

                <FieldInputText
                  label="Registro conselho"
                  value={registroConselho}
                  setValue={setRegistroConselho}
                  isEditField={editableProfissionais}
                  placeholder="Digite o registro do conselho"
                  required
                />

                <FieldAutocomplete
                  label="CBO"
                  isEditField={editableProfissionais}
                  getOptionLabel={(option) => option.no_descricao || ""}
                  options={cboList.filter(filtroCboList)}
                  value={
                    cboList
                      ? cboList.find((option) => option.co_id === cbo)
                      : null
                  }
                  setValue={handleCBOChange}
                  id="combo-box-demo"
                  disablePortal={true}
                  required
                />
              </Stack>
            </Box>

            <Divider />

            <Box sx={styles.containerDadosProfissionais}>
              <Stack direction={"row"} alignItems={"center"} gap={"8px"}>
                <Box style={styles.dadosGerais}>Contato</Box>
                <IconButton
                  onClick={() => {
                    setEditableContato(true);
                  }}
                >
                  <Icon style={styles.iconEdit}>
                    <img src={iconEdit} alt="icone de edição" />
                  </Icon>
                </IconButton>
              </Stack>

              <Stack
                gap={"24px 16px"}
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
                  boxSizing: "border-box !important",
                }}
                width="100%"
                maxWidth="600px"
              >
                <FieldInputText
                  label="Email"
                  value={email}
                  setValue={setEmail}
                  isEditField={editabledadosContato}
                  type="email"
                  required
                  error={!isEmail(email)}
                  helperText={isEmail(email) ? "" : "Informe um email válido"}
                />

                <FieldInputMask
                  mask="(99) 99999-9999"
                  placeholder="(99) 99999-9999"
                  value={telefone}
                  setValue={setTelefone}
                  label="Telefone"
                  isEditField={editabledadosContato}
                  error={telefone?.includes("_")}
                  helperText={
                    telefone?.includes("_") ? "Informe um Telefone válido" : ""
                  }
                  type={"tel"}
                  required
                />
              </Stack>
            </Box>

            <Divider />
            <Box
              sx={{ ...styles.containerDadosProfissionais, maxWidth: "100%" }}
            >
              <Stack direction={"row"} alignItems={"center"} gap={"8px"}>
                <Box style={styles.dadosGerais}>Endereço</Box>
                <IconButton
                  onClick={() => {
                    setEditableEndereco(true);
                  }}
                >
                  <Icon style={styles.iconEdit}>
                    <img src={iconEdit} alt="icone de edição" />
                  </Icon>
                </IconButton>
              </Stack>

              <Stack
                gap={"24px 16px"}
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
                  boxSizing: "border-box !important",
                }}
                width="100%"
              >
                <FieldInputMask
                  mask="99999-999"
                  placeholder="99999-999"
                  label="CEP"
                  value={cep}
                  setValue={setCep}
                  isEditField={editableEndereco}
                  error={isCepInvalid}
                  helperText={isCepInvalid ? "Informe um CEP válido" : ""}
                  onBlur={(event) => {
                    setIsCepInvalid(event.target.value?.includes("_"));
                  }}
                  required
                />
                <FieldInputText
                  label="Logradouro"
                  value={logradouro}
                  setValue={setLogradouro}
                  isEditField={editableEndereco}
                  disabled={editableEndereco ? disableLogradouro : true}
                  required
                  placeholder="Rua, Avenida, Praça, etc."
                />

                <FieldInputText
                  label="Bairro"
                  value={bairro}
                  setValue={setBairro}
                  isEditField={editableEndereco}
                  disabled={editableEndereco ? disableBairro : true}
                  placeholder="Digite o nome do bairro"
                  required
                />

                <FieldInputText
                  label="Número"
                  value={numero}
                  setValue={setNumero}
                  isEditField={editableEndereco}
                  placeholder="Digite o número"
                  required
                />

                <FieldInputText
                  label="Complemento"
                  value={complemento}
                  setValue={setComplemento}
                  isEditField={editableEndereco}
                  placeholder="ex: Ap, Bloco, Casa, etc"
                />

                <FieldInputText
                  label="Município"
                  value={municipio}
                  setValue={setMunicipio}
                  isEditField={editableEndereco}
                  disabled={editableEndereco ? disablebleMunicipio : true}
                  placeholder="Digite o município"
                  required
                />

                <FieldAutocomplete
                  label="Estado"
                  disabled={editableEndereco ? disableEstado : true}
                  isEditField={editableEndereco}
                  getOptionLabel={(option) => option.unidade_federativa}
                  options={ufs}
                  value={
                    estado
                      ? ufs.find((option) => option.codigo_uf === estado)
                      : null
                  }
                  setValue={handleUfChange}
                  required
                />
              </Stack>
            </Box>
            <Divider />
            <Stack direction={"row"} alignItems={"center"} gap={"8px"}>
              <Box style={styles.dadosGerais}>
                Termos de uso e política de privacidade
              </Box>
            </Stack>
            <Box
              gap={"24px 16px"}
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
                boxSizing: "border-box !important",
              }}
              width="100%"
              maxWidth="700px"
            >
              <FormControl>
                <FormControlLabel
                  label={
                    <Box style={styles.checkboxText}>
                      Concordo com os{" "}
                      <span>
                        <a href="/" style={{ color: "#1E729F" }}>
                          termos de uso
                        </a>
                      </span>
                    </Box>
                  }
                  control={
                    <Checkbox
                      checked={termoDeUso}
                      onChange={(event) => {
                        setTermoDeUso(event.target.checked);
                      }}
                      sx={{
                        color: "#3E94C2",
                      }}
                    />
                  }
                />
              </FormControl>

              <FormControl>
                <FormControlLabel
                  label={
                    <Box style={styles.checkboxText}>
                      Concordo com os{" "}
                      <span>
                        <a href="/" style={{ color: "#76AFCD" }}>
                          termos de privacidade
                        </a>
                      </span>
                    </Box>
                  }
                  control={
                    <Checkbox
                      checked={termoDePrivacidade}
                      onChange={(event) => {
                        setTermoDePrivacidade(event.target.checked);
                      }}
                      sx={{
                        color: "#3E94C2",
                      }}
                    />
                  }
                />
              </FormControl>
            </Box>
            <Divider />
            <ThemeProvider theme={theme}>
              <Stack direction={"row"} justifyContent={"flex-end"} gap={"16px"}>
                <Button variant="outlined" onClick={cancelar}>
                  Cancelar
                </Button>
                <Button variant="contained" type="submit">
                  Salvar
                </Button>
              </Stack>
            </ThemeProvider>
          </Paper>
        </Stack>
      </form>
      <DialogSuccess
        open={saveDialog}
        onClose={(value) => {
          setSaveDialog(value);
        }}
        variant="warning"
        buttonAcceptText={"teste"}
        buttonRejectText={""}
        text={"Para concluir o cadastro, preencha os dados pendentes"}
        subTitle={"Dados incompletos"}
      />
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
    </Box>
  );
};

export default LoginPage;
